/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Unsupported_File_Type_ToastInputs */

const en_editor_unsupported_file_type_toast = /** @type {(inputs: Editor_Unsupported_File_Type_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsupported file type. Please try importing a different file.`)
};

const fr_editor_unsupported_file_type_toast = /** @type {(inputs: Editor_Unsupported_File_Type_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de fichier non pris en charge. Veuillez importer un fichier different.`)
};

const de_editor_unsupported_file_type_toast = /** @type {(inputs: Editor_Unsupported_File_Type_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht unterstützter Dateityp. Bitte versuchen Sie, eine andere Datei zu importieren.`)
};

const it_editor_unsupported_file_type_toast = /** @type {(inputs: Editor_Unsupported_File_Type_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di file non supportato. Prova a importare un file diverso.`)
};

const ru_editor_unsupported_file_type_toast = /** @type {(inputs: Editor_Unsupported_File_Type_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неподдерживаемый тип файла. Пожалуйста, попробуйте импортировать другой файл.`)
};

const es_editor_unsupported_file_type_toast = /** @type {(inputs: Editor_Unsupported_File_Type_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de archivo no compatible. Intente importar un archivo diferente.`)
};

const zh_cn2_editor_unsupported_file_type_toast = /** @type {(inputs: Editor_Unsupported_File_Type_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件类型不支持。请尝试导入其他文件。`)
};

const ja_editor_unsupported_file_type_toast = /** @type {(inputs: Editor_Unsupported_File_Type_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サポートされていないファイル形式です。別のファイルをインポートしてください。`)
};

const hi_editor_unsupported_file_type_toast = /** @type {(inputs: Editor_Unsupported_File_Type_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह फ़ाइल प्रकार समर्थित नहीं है। कृपया कोई भिन्न फ़ाइल आयात करने का प्रयास करें।`)
};

const pt_pt2_editor_unsupported_file_type_toast = /** @type {(inputs: Editor_Unsupported_File_Type_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de arquivo não suportado. Tente importar um arquivo diferente.`)
};

/**
* | output |
* | --- |
* | "Unsupported file type. Please try importing a different file." |
*
* @param {Editor_Unsupported_File_Type_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_unsupported_file_type_toast = /** @type {((inputs?: Editor_Unsupported_File_Type_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Unsupported_File_Type_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_unsupported_file_type_toast(inputs)
	if (locale === "de") return de_editor_unsupported_file_type_toast(inputs)
	if (locale === "it") return it_editor_unsupported_file_type_toast(inputs)
	if (locale === "ru") return ru_editor_unsupported_file_type_toast(inputs)
	if (locale === "es") return es_editor_unsupported_file_type_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_unsupported_file_type_toast(inputs)
	if (locale === "ja") return ja_editor_unsupported_file_type_toast(inputs)
	if (locale === "hi") return hi_editor_unsupported_file_type_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_unsupported_file_type_toast(inputs)
	return en_editor_unsupported_file_type_toast(inputs)
});